module.exports = __webpack_public_path__ + "img/chevron-down-purple-thick.5c8f48a6.svg";